<template>
  <button
    type="button"
    class="rounded-full h-44 bg-[--raw-red] px-10 text-[--raw-offwhite] transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[--raw-black] active:bg-[--raw-black]"
    @click="handleClick"
  >
    <span class="raw-cta-3 flex items-center justify-center gap-4">
      <RevIllustration
        src="/mine-my-phone/icons/heart--flat.svg"
        alt=""
        aria-hidden="true"
        :width="26"
        :height="26"
        class="invert"
      />
      {{ i18n(translations.cta) }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import { useModalState } from '~/scopes/campaign/composables/useModalState'

import translations from './TakeAction.translations'

const i18n = useI18n()
const { activeAction, openAction, closeView } = useModalState()

// The layered `?view=`, not the route, so toggling off leaves the reader where it was.
function handleClick() {
  if (activeAction.value) closeView()
  else openAction()
}
</script>
